export const PorfolioData = [
    {
        id: 1,
        title: "StoVoo – Food, Learning & Live Experiences",
        desc: "A food delivery and culinary platform to order meals, learn recipes, join live streams, and plan dishes with your favorite vendors.",
        image: "/images/StoVoo.png",
        tag: "Web App",
        tech: ["React", "Tailwind", "Firebase"],
        url: "https://www.stovoo.com/",
    },
    {
        id: 2,
        title: "Luxury Hotel Website",
        desc: "An elegant hotel website showcasing premium room categories, amenities, and seamless booking experience for guests seeking comfort and sophistication.",
        image: "/images/hotel.jpg",
        tag: "Web App",
        tech: ["Next", "Tailwind", "Adonis.js"],
        url: "https://pio.atslng.com/lagos",
    },
    {
        id: 4,
        title: "A Brand Identity design for a Tech Startup",
        desc: "A comprehensive brand identity design project for a tech startup, including logo design, color palette, typography, and brand guidelines.",
        image: "/images/idealtech.png",
        tag: "Graphic Design",
        tech: ["Photoshop", "Illustrator", "After Effects"],
        url: "https://drive.google.com/drive/folders/1ipQc9F3YNpY-8kSPZheLb5SYkFpURWZu",
    },
    {
        id: 3,
        title: "A study app for medical students",
        desc: "An app designed to help medical students efficiently study and retain complex medical information through interactive tools and resources.",
        image: "/images/Medtales.png",
        tag: "Mobile App",
        tech: ["React Native", "express.js", "mongoDB"],
        url: "#",
    },
    {
        id: 5,
        title: "Hotel Management SaaS Platform",
        desc: "A comprehensive cloud-based hotel management system streamlining reservations, room inventory, guest services, billing, and analytics for hospitality businesses.",
        image: "/images/hotel-saas.jpg",
        tag: "Web App",
        tech: ["React", "Adonis.js", "MySQL"],
        url: "#"
    },
    {
        id: 6,
        title: "Advanced Crypto Analytics Platform",
        desc: "An intuitive cryptocurrency dashboard providing live market data, trading signals, and detailed insights for informed investment decisions.",
        image: "/images/crypto.jpg",
        tag: "UI/UX",
        tech: ["Figma", "Lucidchart", "Adobe Illustrator"],
        url: "#",
    },
];